import { createRouter, createWebHistory } from "vue-router";
import HomeView from "@/views/HomeView.vue";
import ServiceView from "@/views/ServiceView.vue";
import AboutView from "@/views/AboutView.vue";
import ContactsView from "@/views/ContactsView";
import GetInvolvedView from "@/views/GetInvolvedView.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/about",
    name: "about",
    component: AboutView,
  },
  {
    path: "/services",
    name: "serviceview",
    component: ServiceView,
  },
  {
    path: "/contacts",
    name: "contactview",
    component: ContactsView,
  },
  {
    path: "/getinvolved",
    name: "getinvolved",
    component: GetInvolvedView,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition; // For navigation like back/forward buttons
    } else {
      return { top: 0 }; // Scroll to the top for new pages
    }
  },
});

export default router;
